/* Bootleg Bath — fragrance-note icons.

   Lauren's artwork, processed 2026-08-05 from ui-media/09_fragrance_icons:
   cream background knocked out to transparent, trimmed to the ink, and
   normalised onto one 240x240 square so every icon sits at the same optical
   size and centre. Source files are untouched.

   To add or redraw one: drop the PNG in that folder and re-run the processing
   step — the filename becomes the icon key.                                   */

var BB_ICON = function(key){
  return '<img class="bb-ico" src="' + window.BB_ICON_BASE + 'bb-icon-' + key + '.png"' +
         ' alt="" width="240" height="240" loading="lazy">';
};

window.BB_SCENT_ICON_SVG = {};
[ 'amber','as','citrus','coconut-lime','coffee','euclyptus','ff','fff','grapefruit','gt','hps','hsc',
  'lavender','mt','mint','psc','peony','rosemary','sw','swps','vanilla',
  'otc','rht','wd',
  'warm-cashmere','white-birch','clean-linen','peach','eucalyptus'
].forEach(function(k){ window.BB_SCENT_ICON_SVG[k] = BB_ICON(k); });

/* scent_notes value -> icon key.
   Only the ones whose names match Lauren's own labels are wired. Anything not
   listed simply draws no icon rather than being guessed at — the attribution
   sheet is the authority and will replace this wholesale. */
window.BB_SCENT_ICON_MAP = {
  'Lavender':              'lavender',
  'Vanilla':               'vanilla',
  'Sandalwood':            'sw',
  'Mahogany Teakwood':     'mt',
  'Eucalyptus Mint':       'euclyptus',
  'Grapefruit & Bergamot': 'grapefruit',
  'Coffee / Cold Brew':    'coffee',
  'Fresh Fraser Fir':      'fff',
  'Pistachio Salted Caramel': 'psc'
  ,
  /* Lauren's own artwork, 2026-09-10. HSC is drawn and loaded ahead of the
     product existing. */
  'Harvest Pumpkin Spice': 'hps',
  'Fall Favorites':        'ff',
  'Apple pie & vanilla ice cream': 'as',
  /* Commute flights — each 3-pack has its own icon, not a fragrance icon. */
  'Rush Hour Therapy':     'rht',
  'Off the Clock':         'otc',
  'Guilt Trip':            'gt',
  'Windows Down':          'wd'
  /* NOT mapped yet:
       'Apple pie & vanilla ice cream'  (American Summer)
       'Love Spell'
     Unused icons: amber, citrus, coconut-lime, hsc, mint, peony, rosemary,
     swps, warm-cashmere, white-birch, clean-linen, peach                    */
};

/* icon key -> hex from FILL_icon_color. Rendered muted behind the icon.
   Empty until the sheet comes back; swatches fall back to the theme line. */
window.BB_SCENT_ICON_COLOR = {
  "vanilla": "#efcb84",
  "grapefruit": "#efa885",
  "citrus": "#d7f570",
  "coffee": "#4f3e2f",
  "mint": "#43e9cc",
  "lavender": "#b282e2",
  "sw": "#40260f",
  "mt": "#40260f",
  "psc": "#e9b443",
  "fff": "#1b8d53",
  "peach": "#f29797",
  "rosemary": "#43e9d3",
  "eucalyptus": "#679c83",
  "hps": "#E2701C",
  /* Fall / Experience */
  "ff":  "#C4552E",
  "as":  "#D89B4E",
  /* Commute flights — a spread across the wheel so four sit side by side
     on a card without any two reading as the same colour. */
  "rht": "#C8443A",
  "otc": "#E8A93F",
  "gt":  "#DE8FA0",
  "wd":  "#6BA5C0"
};

/* product group -> the heading shown for the whole family. Whatever is left of
   a product's title once this is removed becomes the line underneath, so
   "Lavender Car Air Freshener" gives "Car Air Freshener" / "Lavender", while
   "Cold Brew Scrub Bar" keeps its full name under "Hand Crafted Bar Soap".

   Defaults live here so the drawer has them on EVERY page. The collection grid
   section's Family name blocks override and extend them. Should move to a
   bootleg.family_label metafield when the attribution sheet is written. */
window.BB_FAMILY_LABELS_DEFAULT = {
  'Bar Soap':      'Hand Crafted Bar Soap',
  'Car Freshener': 'Car Air Freshener'
};
